module.exports = __webpack_public_path__ + "r-v3/img/Q.aa4827c8.svg";